import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NavigationComponent } from './navigation/navigation.component';
import { CookiesComponent } from './cookies/cookies.component';

const routes: Routes = [
  { path: '', component: NavigationComponent },
  { path: 'cookies', component: CookiesComponent },
  { path: '**', component: NavigationComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
